import { useState, useEffect } from "react";
import styles from "./HelpButton.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

function HelpModal({ isOpen, onClose, position, children }) {

  useEffect(() => {

    const handleClick = (event) => {
      if (event.target.tagName === "A") {
        onClose();
      }
    };

    const modalElement = document.querySelector(`.${styles.modal}`);
    if (!modalElement) return;
    modalElement.addEventListener("click", handleClick);

    return () => {
      modalElement.removeEventListener("click", handleClick);
    };
  }, [onClose]);      

  // Close the modal when the backdrop is clicked
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const modalStyle = {
    top: position.top + 20,
    left: position.left - 90,
  }

  if (!isOpen) return null;

  // Prevent clicks inside the modal from closing the modal
  const handleModalClick = (event) => {
    event.stopPropagation();
  }

  return (
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div className={styles.modal}  style={modalStyle} onClick={handleModalClick}>
        <button onClick={onClose} className={styles.closeButton}><FontAwesomeIcon icon={faXmark} /></button>
        {children}
      </div>
    </div>
  );
}

function HelpButton({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const openModal = (event) => {
    const buttonPosition = event.currentTarget.getBoundingClientRect();
    setModalPosition({
      top: buttonPosition.bottom,
      left: buttonPosition.left,
    });
    setIsOpen(true);
  }

  return (
    <>
      <button className={styles.helpButton} onClick={openModal}>
        <FontAwesomeIcon icon={faCircleQuestion} />
      </button>
      <HelpModal isOpen={isOpen} onClose={() => setIsOpen(false)} position={modalPosition}>
        {children}
      </HelpModal>
    </>
  );
}

export default HelpButton;
